import { ButtonBase, Typography } from '@material-ui/core'
import moment from 'moment'
import React, { useState, useMemo } from 'react'

import { DateObject, gregorianToJalaali } from '../../helpers/date'
import { getTranslate, lang } from '../../localization'
import { DailyAllocationDetail } from '../../types/inventoryAllocationLogs'
import ReservesModal from './ReservesModal'
import useStyles from './styles/InventoryRoomtypeBox.styles'

interface AttemptRowProps {
  dailyLogAllocations: DailyAllocationDetail[]
  name: string
  userEmail: string
  attemptDate: string
  attemptTime: string
  selectedDateInDatePicker: DateObject
  attemptID: string
}

const AttemptRow: React.FC<AttemptRowProps> = ({
  name,
  dailyLogAllocations,
  attemptDate,
  attemptTime,
  userEmail,
  selectedDateInDatePicker,
  attemptID
}) => {
  const classes = useStyles()
  const [selectedDate, setSelectedDate] = useState<string>('')
  const [reservesModalIsOpen, setReservesModalIsOpen] = useState<boolean>(false)

  // Helper to filter the dailyLogAllocations based on the selected date range
  const filteredAllocations = useMemo(() => {
    const startDate = moment(selectedDateInDatePicker.gregorianStartDate)
    const endDate = moment(selectedDateInDatePicker.gregorianEndDate)

    return dailyLogAllocations.filter((allocation) => {
      const allocationDate = moment(allocation.date)
      return allocationDate.isBetween(startDate, endDate, 'day', '[]') // Inclusive range
    })
  }, [dailyLogAllocations, selectedDateInDatePicker])

  const handleClick = (date: string) => {
    setReservesModalIsOpen(true)
    setSelectedDate(date)
  }

  return (
    <div>
      <div className={classes.roomTypeRow}>
        <div>
          <div className={classes.rowNameContainer}>
            <Typography variant="body1" className={classes.requestName}>
              {getTranslate(name)}
            </Typography>{' '}
            <Typography variant="body2" className={classes.time}>
              {lang === 'fa' ? gregorianToJalaali(attemptDate) : attemptDate}
            </Typography>
          </div>
          <div className={classes.rowNameContainer}>
            <Typography variant="h4" className={classes.rowName}>
              {getTranslate(userEmail)}
            </Typography>{' '}
            <Typography variant="body2" className={classes.time}>
              {attemptTime}
            </Typography>
          </div>
        </div>

        {filteredAllocations?.map((allocation) =>
          allocation.successful === 0 && allocation.requested === 0 ? (
            <div></div>
          ) : (
            <div
              key={`${name}-${allocation.date}`}
              className={`${classes.dayContainer} ${
                allocation.successful < allocation.requested
                  ? classes.failedBackground // Failed allocation
                  : classes.successBackground // Successful allocation
              }`}>
              <ButtonBase onClick={() => handleClick(allocation.date)}>
                <Typography variant="body2" className={classes.successText}>
                  {allocation.successful}
                </Typography>
                <Typography variant="body2" className={classes.numberOfRooms}>
                  {` / ${allocation.requested}`}
                </Typography>
              </ButtonBase>
            </div>
          )
        )}
      </div>

      <ReservesModal
        attemptID={attemptID}
        date={selectedDate}
        isOpen={reservesModalIsOpen}
        onClose={() => {
          setReservesModalIsOpen(false)
        }}
      />
    </div>
  )
}

export default AttemptRow
